import { createFileRoute } from "@tanstack/react-router";
import ConnectAccount from "src/pages/Link/Products/ConnectAccount/ConnectAccount";

export const Route = createFileRoute("/link/connect-account")({
	component: () => <ConnectAccount product='TRANSACTIONS' />
});
